import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEdc_sharing_groupIdOptimize_inefficiency = z.any()
export type TagsPostEdc_sharing_groupIdOptimize_inefficiency = z.infer<typeof tagsPostEdc_sharing_groupIdOptimize_inefficiency>

export const paramsPostEdc_sharing_groupIdOptimize_inefficiency = z.object({ "groupId": z.string() })
export type ParamsPostEdc_sharing_groupIdOptimize_inefficiency = z.infer<typeof paramsPostEdc_sharing_groupIdOptimize_inefficiency>

export const bodyPostEdc_sharing_groupIdOptimize_inefficiency = z.object({ "from": z.string().date(), "to": z.string().date(), "thresholdPercent": z.number().gte(0).lte(100), "startHour": z.number().int().gte(0).lte(23), "endHour": z.number().int().gte(1).lte(24), "maxExportKw": z.number().gte(0).lte(1000000).optional() })
export type BodyPostEdc_sharing_groupIdOptimize_inefficiency = z.infer<typeof bodyPostEdc_sharing_groupIdOptimize_inefficiency>

export const responsePostEdc_sharing_groupIdOptimize_inefficiency = z.object({ "payload": z.object({ "totals": z.object({ "generation": z.number(), "consumption": z.number(), "shared": z.number(), "received": z.number(), "exported": z.number(), "purchased": z.number(), "missed": z.number() }), "points": z.array(z.object({ "key": z.string(), "shared": z.number() })), "keys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "improvement": z.number(), "better": z.boolean(), "inefficientHours": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEdc_sharing_groupIdOptimize_inefficiency = z.infer<typeof responsePostEdc_sharing_groupIdOptimize_inefficiency>

interface IPostEdc_sharing_groupIdOptimize_inefficiency extends BaseMethodType {
  tags: TagsPostEdc_sharing_groupIdOptimize_inefficiency,
  params: ParamsPostEdc_sharing_groupIdOptimize_inefficiency,
  body: BodyPostEdc_sharing_groupIdOptimize_inefficiency,
  response: ResponsePostEdc_sharing_groupIdOptimize_inefficiency
}
export const URL = '/edc-sharing/:groupId/optimize-inefficiency'
export const validation = {
  post: {
    tags: tagsPostEdc_sharing_groupIdOptimize_inefficiency,
    params: paramsPostEdc_sharing_groupIdOptimize_inefficiency,
    body: bodyPostEdc_sharing_groupIdOptimize_inefficiency,
    response: responsePostEdc_sharing_groupIdOptimize_inefficiency
  }
}
export interface Edc_sharing_groupIdOptimize_inefficiency extends BaseRouteType {
  post: IPostEdc_sharing_groupIdOptimize_inefficiency
}